import React, { useEffect } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { Switch, Route, withRouter, Redirect } from "react-router-dom"

import Login from "./containers/Login"
import Dashboard from "./containers/Dashboard"
import Registration from "./containers/Registration"
import ForgotPassword from "containers/ForgotPassword"
import ForgotSecurityPin from "containers/ForgotSecurityPin"
import { getItem } from "./utils/tokenStore"

import { getProfile } from 'actions/profile' 
import PaymentFailed from "containers/Registration/PaymentFailed"
import PaymentSuccessful from "containers/Registration/PaymentSuccessful"
import PaymentPending from "containers/Registration/PaymentPending"

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getItem( 'TECHBASE_TOKEN' ) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props },
          }}
        />
      )
    }
  />
)

const CustomRouter = ({ location, ...props }) => {
  useEffect(()=>{
    if( getItem( 'TECHBASE_TOKEN' ) ){
      props.getProfile( props.data.ClientReducer )
    }
  },[ props.data.ClientReducer.clientInfo ])
  return (
    <Switch>
      <Route exact path="/login" component={Login} initialPath />
      <Route exact path="/forgot-password" component={ForgotPassword} initialPath />
      <Route exact path="/forgot-security-pin" component={ForgotSecurityPin} initialPath />
      <Route exact path="/register/payment_successful/*" component={PaymentSuccessful}/>
      <Route exact path="/register/payment_pending/*" component={PaymentPending}/>
      <Route exact path="/register/payment_failed/*" component={PaymentFailed}/>
      <Route path="/register" component={Registration} />
      <PrivateRoute path="/dashboard" component={ Dashboard } />
      <Redirect from={"/"} to={"/login"} />
    </Switch>
  )
}

const mapStateToProps = (state) => ({ 
  data: state
})
export default compose(
  connect(mapStateToProps, { getProfile } ), 
  withRouter
)(CustomRouter)
